import instance from '../../axios';

// Function to get request headers
const getRequestHeader = (file = false) => {
  const userdata = localStorage.getItem('userdata');
  const controller = new AbortController();
  const signal = controller.signal;

  if (userdata) {
    const dataObj = JSON.parse(userdata);
    return {
      headers: {
        'Content-Type': file ? 'multipart/form-data' : 'application/json',
        Authorization: dataObj.token,
        'X-VERIFY-STRING': dataObj.verifystr,
      },
      signal: signal,
    };
  }

  return {
    headers: {
      'Content-Type': file ? 'multipart/form-data' : 'application/json',
    },
    signal: signal,
  };
};

// Function to make a POST request
export const post = async (url, data = {}, file = false) => {
  try {
    const response = await instance.post(url, data, getRequestHeader(file));
    return response;
  } catch (error) {
    console.error('Error in POST request:', error);
    throw error;
  }
};
